import { Component,	Input } from '@angular/core';

import { VBrick360UtilService } from '../threeSixty/VBrick360Util.Service';

import { VideogularComponent } from './videogular/Videogular.Component';

import { VbPlaybackManagerComponent } from './VbPlaybackManager.Component';

import styles from './VbNoSupportedPlaybacks.module.less';

@Component({
	selector: 'vb-no-supported-playbacks',
	host: {
		'[class]': 'styles.root + " " + (isSmallSizePlayer ? styles.smallSizePlayer : "")'
	},
	template: `
		<span [ngClass]="styles.warningSign" class="glyphicons white circle_exclamation_mark"></span>
		<span [hidden]="is360PlaybackNotSupported">{{ translations.playbackNotSupported }}</span>
		<span [hidden]="!is360PlaybackNotSupported">{{ translations.playback360NotSupported }}</span>`,
    standalone: false
})
export class VbNoSupportedPlaybacksComponent {
	@Input() public translations: { [key: string]: string };
	@Input() public playbackManager: VbPlaybackManagerComponent;
	@Input() public isSmallSizePlayer: boolean;

	public readonly styles = styles;
	constructor(
		private VBrick360Util: VBrick360UtilService
	) {}

	public get is360PlaybackNotSupported(): boolean {
		if (!this.playbackManager || !this.playbackManager.playbackOptions) {
			return false;
		}

		const { playbackOptions } = this.playbackManager;

		return playbackOptions.length &&
			playbackOptions.every(option => option.is360Enabled) &&
			this.VBrick360Util.isUnsupportedBrowser();
	}
}
